export enum NumberUsage {
    Phone,
    Fax,
    PhoneAndFax,
}